<template>
  <nav class="c-nav--sub">
    <ul>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-ab/" title="USB 2.0 Kabel AB">
          USB 2.0 Kabel AB
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-ab-gewinkelt/" title="USB 2.0 Kabel AB gewinkelt">
          USB 2.0 Kabel AB gewinkelt
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-aa-und-bb/" title="USB 2.0 Kabel AA und BB">
          USB 2.0 Kabel AA und BB
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-mini-b/" title="USB 2.0 Kabel Mini-B">
          USB 2.0 Kabel Mini-B
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-mini-b-gewinkelt/" title="USB 2.0 Kabel Mini B gewinkelt">
          USB 2.0 Kabel Mini B gewinkelt
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-micro/" title="USB 2.0 Kabel Micro">
          USB 2.0 Kabel Micro
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-kabel-micro-gewinkelt/" title="USB 2.0 Kabel Micro gewinkelt">
          USB 2.0 Kabel Micro gewinkelt
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-verlaengerungen/" title="USB 2.0 Verlängerungen">
          USB 2.0 Verlängerungen
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-verlaengerungen-aktiv/" title="USB 2.0 Verlängerungen aktiv">
          USB 2.0 Verlängerungen aktiv
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-2.0-montagekabel-industriekabel/" title="USB 2.0 Montagekabel + Industriekabel">
          USB 2.0 Montagekabel + Industriekabel
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-otg-on-the-go/" title="USB OTG - On The Go">
          USB OTG - On The Go
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/interne-usb-kabel/" title="Interne USB-Kabel">
          Interne USB-Kabel
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-adapter-konverter/" title="USB Adapter &amp; Konverter">
          USB Adapter &amp; Konverter
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-hubs-usb-umschalter/" title="USB HUBs + USB Umschalter">
          USB HUBs + USB Umschalter
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-karten/" title="USB Karten">
          USB Karten
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-kleinteile-adapter-stecker-staubschutzkappe/" title="USB-Kleinteile: Adapter, Stecker, Staubschutzkappe">
          USB-Kleinteile: Adapter, Stecker, Staubschutzkappe
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/externe-festplatten-gehaeuse-fuer-sata/" title="Externe Festplatten-Gehäuse für SATA">
          Externe Festplatten-Gehäuse für SATA
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/externe-festplatten-gehaeuse-fuer-ide/" title="Externe Festplatten-Gehäuse für IDE">
          Externe Festplatten-Gehäuse für IDE
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-kartenleser-und-stickstaender/" title="USB-Kartenleser und Stickständer">
          USB-Kartenleser und Stickständer
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/usb-diverses/" title="USB diverses">
          USB diverses
        </a>
      </li>
      <li class="" role="menuitem">
        <a class="" href="https://www.partsdata.de/usb-2.0/ausverkauf-sonderpreise/" title="Ausverkauf / Sonderpreise">
          Ausverkauf / Sonderpreise
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'SubNavigation'
}
</script>

<style scoped lang="sass">
  .c-nav--sub
    //@include span-columns(3)
    padding-top: 2em
    ul
      margin: 0
      padding: 0
      li
        list-style: none
        font-size: 1.077rem
        height: 100%
        border-left: 4px solid $light-grey

        &:last-child
          border-bottom: 1px solid $light-grey

        &:hover
          border-left: 4px solid $orange

        &.is--active
          border-left: 4px solid $orange

        ul
          border: none
          margin-left: -4px

        ul li
          border-top: none
          padding-left: 1em



        ul li a
          font-size: 0.89em
          border-top: none
          &.is--active
            padding-left: 1em
            &:before
              content: ""


        ul li:last-child
          padding-bottom: 1.2em
          border-bottom: none

        a
          color: #000
          position: relative
          padding: 0.9em 0.9em 0.9em 1em
          border-top: 1px solid #dae4e9
          display: block
          text-decoration: none
          &:hover
            color: $orange

          &.is--active
            font-weight: 600
            color: $orange
            padding-left: 2em
            &:before
              content: "\f107"
              font-family: FontAwesome
              //color: lighten($orange, 10%)
              color: lighten($orange, 10%)
              display: block
              position: absolute
              left: 0.8em
              top: 1.18em

</style>
